import React, { useEffect, useState } from 'react';
import { useBranch } from '../../../layouts/BranchContext'; 
import {
  Button,
  Container,
  Box,
  Modal,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Tooltip,
  Chip,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate, useParams } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import FormHelperText from '@mui/material/FormHelperText';
import CloseIcon from '@mui/icons-material/Close';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CustomTableScrollbar = styled('div')(({ theme }) => ({
  overflowY: 'auto',
  backgroundColor: theme.palette.background.paper,
  '&::-webkit-scrollbar': {
    width: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,0.2)'
        : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,0.3)'
        : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${
    theme.palette.mode === 'dark'
      ? 'rgba(255,255,255,0.2)'
      : 'rgba(0,0,0,0.2)'
  } transparent`,
}));

const COUNTRY_CODES = [
  ['+91', '🇮🇳 +91 (India)'],
  ['+1', '🇺🇸 +1 (USA)'],
  ['+44', '🇬🇧 +44 (UK)'],
  ['+61', '🇦🇺 +61 (Australia)'],
  ['+971', '🇦🇪 +971 (UAE)'],
  ['+65', '🇸🇬 +65 (Singapore)'],
  ['+60', '🇲🇾 +60 (Malaysia)'],
  ['+966', '🇸🇦 +966 (Saudi Arabia)'],
  ['+974', '🇶🇦 +974 (Qatar)'],
  ['+968', '🇴🇲 +968 (Oman)'],
  ['+973', '🇧🇭 +973 (Bahrain)'],
  ['+965', '🇰🇼 +965 (Kuwait)'],
  ['+64', '🇳🇿 +64 (New Zealand)'],
  ['+49', '🇩🇪 +49 (Germany)'],
  ['+33', '🇫🇷 +33 (France)'],
  ['+81', '🇯🇵 +81 (Japan)'],
  ['+86', '🇨🇳 +86 (China)'],
  ['+92', '🇵🇰 +92 (Pakistan)'],
  ['+880', '🇧🇩 +880 (Bangladesh)'],
  ['+94', '🇱🇰 +94 (Sri Lanka)'],
  ['+977', '🇳🇵 +977 (Nepal)'],
  ['+27', '🇿🇦 +27 (South Africa)'],
  ['+234', '🇳🇬 +234 (Nigeria)'],
  ['+254', '🇰🇪 +254 (Kenya)'],
];

const EditRegistration = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { registrationId } = useParams();

  const [sessionUser] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem('user') || '{}');
    } catch {
      return {};
    }
  });

  const isMainBranchAdmin =
    sessionUser?.is_main_branch_admin === true;

  const isBranchAdmin =
    sessionUser?.is_admin === true ||
    sessionUser?.is_main_branch_admin === true ||
    sessionUser?.is_branch_super_admin === true;

  const userBranchId = sessionUser?.branch_id || '';
  const userOrganizationId = sessionUser?.organization_id || '';

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [allStates, setAllStates] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [nationalities, setNationalities] = useState([]);
  const [courses, setCourses] = useState([]);
  const [enquiries, setEnquiries] = useState([]);

  const [courseModalOpen, setCourseModalOpen] = useState(false);
  const [tempCourses, setTempCourses] = useState([]);

  const [enquiryModalOpen, setEnquiryModalOpen] = useState(false);
  const [selectedEnquiry, setSelectedEnquiry] = useState(null);
  const [enquirySearchTerm, setEnquirySearchTerm] = useState('');

  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
    const { selectedBranchId, branchList: branches } = useBranch();

  const [organizationId] = useState(userOrganizationId || '');

  const [formData, setFormData] = useState({
    sendSMS: false,
    registrationCode: '',
    registrationDate: new Date().toISOString().split('T')[0],
    candidateName: '',
    gender: '',
    mobileNo: '',
    email: '',
    dateOfBirth: '',
    country: '',
    state: '',
    city: '',
    address: '',
    nationality: '',
    registrationFee: '',
    courses: [],
    branch: userBranchId || '',
  });

  const [mobileCountryCode, setMobileCountryCode] = useState('+91');

  const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

  const token = localStorage.getItem('accessToken');

  const staticGenderData = [
    { id: 1, name: 'Male' },
    { id: 2, name: 'Female' },
    { id: 3, name: 'Other' },
  ];

const inputSx = {
  mb: 3,
  '& .MuiInputLabel-root': {
    color: theme.palette.text.primary,
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: theme.palette.primary.main,
  },
  '& .MuiInputLabel-root.Mui-disabled': {
    color: theme.palette.text.primary,
    opacity: 0.7,
  },
  '& .MuiFormHelperText-root:not(.Mui-error)': {
    color: theme.palette.mode === 'dark' ? '#e0e0e0' : '#484848',
    fontWeight: 500,
    opacity: 1,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.text.primary,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.primary.main,
  },
};

  /*
   * STEP 1:
   * Fetch registration-independent master data and registration itself.
   * Branch rules:
   * Main Branch Admin -> all active branches of organization.
   * Sub Branch Admin -> only own branch.
   */
  useEffect(() => {
    const fetchInitialData = async () => {
      if (!token) {
        setFetchError('No authentication token found');
        setLoading(false);
        return;
      }

      setLoading(true);
      setFetchError(null);

      try {
        const headers = {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        };

       const [
  countriesRes,
  natRes,
  statesRes,
  citiesRes,
  regRes,
] = await Promise.all([
  fetch(`${API_BASE_URL}/api/master/countries/`, { headers }),
  fetch(`${API_BASE_URL}/api/master/nationalities/`, { headers }),
  fetch(`${API_BASE_URL}/api/master/states/`, { headers }),
  fetch(`${API_BASE_URL}/api/master/cities/`, { headers }),
  fetch(
    `${API_BASE_URL}/api/student_details/registrations/${registrationId}/`,
    { headers }
  ),
]);

        if (!regRes.ok) {
          throw new Error(`Registration fetch failed: ${regRes.status}`);
        }

        const countriesData = await countriesRes.json();
        const natData = await natRes.json();
        const statesData = await statesRes.json();
        const citiesData = await citiesRes.json();
        const reg = await regRes.json();

        const countriesList = Array.isArray(countriesData)
          ? countriesData
          : countriesData.data || [];

        const natList = Array.isArray(natData)
          ? natData
          : natData.data || [];

       const rawStates = Array.isArray(statesData)
  ? statesData
  : statesData.data || [];

const rawCities = Array.isArray(citiesData)
  ? citiesData
  : citiesData.data || [];

const mappedStates = rawStates.map((state) => ({
  stateId: state.id,
  stateName: state.name || state.state_name || state,
  countryId: state.country || state.country_id,
}));

const mappedCities = rawCities.map((city) => ({
  cityId: city.id,
  cityName: city.name || city.city_name || city,
  stateId: city.state || city.state_id,
}));

setCountries(countriesList);
setNationalities(natList);
setAllStates(mappedStates);
setStates(mappedStates);
setAllCities(mappedCities);
setCities(mappedCities);

        /*
         * For branch admins, login branch has priority.
         * This prevents a sub branch admin from editing the registration
         * under another branch.
         */
                const effectiveBranchId = selectedBranchId;

        const countryObj = countriesList.find(
          (country) =>
            String(country.id) ===
              String(reg.country || reg.country_id) ||
            String(country.name) === String(reg.country)
        );

        const stateObj = mappedStates.find(
          (state) =>
            String(state.stateId) ===
              String(reg.state || reg.state_id) ||
            String(state.stateName) === String(reg.state)
        );

        const cityObj = mappedCities.find(
          (city) =>
            String(city.cityId) ===
              String(reg.city || reg.city_id) ||
            String(city.cityName) === String(reg.city)
        );

        const natObj = natList.find(
          (nat) =>
            String(nat.id) ===
              String(reg.nationality || reg.nationality_id) ||
            String(nat.name || nat.nationality) ===
              String(reg.nationality)
        );

        const rawCourseIds =
          Array.isArray(reg.courses)
            ? reg.courses
            : Array.isArray(reg.course_ids)
              ? reg.course_ids
              : [];

        const courseNamesFromResponse = Array.isArray(
          reg.course_names
        )
          ? reg.course_names
          : [];

        const prefilledCourses =
          courseNamesFromResponse.length > 0
            ? courseNamesFromResponse
            : rawCourseIds.map((id) => String(id));

        setFormData({
          sendSMS: reg.send_sms ?? false,
          registrationCode: reg.registration_code || '',
          registrationDate:
            reg.registration_date ||
            new Date().toISOString().split('T')[0],
          candidateName:
            reg.candidate_name || reg.student_name || '',
          gender: reg.gender || '',
          mobileNo: reg.mobile_no || reg.phone || '',
          email: reg.email || '',
          dateOfBirth: reg.dob || reg.date_of_birth || '',
          country:
            countryObj?.name ||
            countryObj?.country_name ||
            reg.country_name ||
            '',
          state: stateObj?.stateName || reg.state_name || '',
          city: cityObj?.cityName || reg.city_name || '',
          address: reg.address || '',
          nationality:
            natObj?.name ||
            natObj?.nationality ||
            natObj?.nationality_name ||
            reg.nationality_name ||
            '',
          registrationFee:
            reg.registration_fee ?? reg.fee ?? '',
          courses: prefilledCourses,
          branch: effectiveBranchId,
        });

        if (reg.enquiry || reg.enquiry_id) {
          const enquiryId = reg.enquiry || reg.enquiry_id;

          setSelectedEnquiry({
            id: enquiryId,
            enquiry_code:
              reg.enquiry_code || `ENQ-${enquiryId}`,
            student_name:
              reg.candidate_name || reg.student_name || '',
          });
        }

        /*
         * If registration has a complete international number,
         * split the country code for the UI.
         */
        const mobile = reg.mobile_no || reg.phone || '';
        if (mobile) {
          let detectedCode = '+91';
          let detectedNumber = String(mobile);

          for (const [code] of COUNTRY_CODES) {
            if (detectedNumber.startsWith(code)) {
              detectedCode = code;
              detectedNumber = detectedNumber
                .slice(code.length)
                .replace(/\D/g, '');
              break;
            }
          }

          if (detectedNumber === String(mobile)) {
            const digits = String(mobile).replace(/\D/g, '');
            detectedNumber =
              digits.length > 10 ? digits.slice(-10) : digits;
          }

          setMobileCountryCode(detectedCode);
          setFormData((prev) => ({
            ...prev,
            mobileNo: detectedNumber,
          }));
        }
      } catch (err) {
        console.error('Fetch error:', err);
        setFetchError(
          err.message || 'Failed to load registration data'
        );
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, [
    registrationId,
    token,
    API_BASE_URL,
    organizationId,
    isBranchAdmin,
    isMainBranchAdmin,
    userBranchId,
  ]);

  /*
   * STEP 2:
   * Branch-dependent courses and enquiries.
   * Main Branch Admin can change branch.
   * Sub Branch Admin remains locked to own branch.
   */
  useEffect(() => {
    const fetchBranchDependentData = async () => {
      if (!token || !organizationId || !selectedBranchId) {
        setCourses([]);
        setEnquiries([]);
        return;
      }

      try {
        const headers = {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        };

const params = new URLSearchParams();
params.append('organisation', organizationId);
params.append('branch', selectedBranchId);

        const [coursesRes, enquiryRes] = await Promise.all([
          fetch(
            `${API_BASE_URL}/api/course/courses/?${params.toString()}`,
            { headers }
          ),
          fetch(
            `${API_BASE_URL}/api/student_details/enquiries/?${params.toString()}`,
            { headers }
          ),
        ]);

        const coursesData = await coursesRes.json();
        const enquiryData = await enquiryRes.json();

        const coursesList =
          coursesData.results ||
          (Array.isArray(coursesData)
            ? coursesData
            : coursesData.data || []);

        const enquiriesList =
          enquiryData.results ||
          (Array.isArray(enquiryData)
            ? enquiryData
            : enquiryData.data || []);

        setCourses(coursesList);
        setEnquiries(enquiriesList);
      } catch (err) {
        console.error(
          'Branch-dependent data fetch error:',
          err
        );
        setCourses([]);
        setEnquiries([]);
      }
    };

    fetchBranchDependentData();
  }, [selectedBranchId, organizationId, token, API_BASE_URL]);

  /*
   * Keep course selections when course API finishes loading.
   * If API provides matching IDs, convert those IDs to names.
   */
  useEffect(() => {
    if (!courses.length || !formData.courses.length) return;

    const converted = formData.courses.map((value) => {
      const course = courses.find(
        (item) =>
          String(item.id) === String(value) ||
          String(
            item.name || item.course_name || item.title || ''
          ) === String(value)
      );

      return (
        course?.name ||
        course?.course_name ||
        course?.title ||
        String(value)
      );
    });

    if (
      JSON.stringify(converted) !==
      JSON.stringify(formData.courses)
    ) {
      setFormData((prev) => ({
        ...prev,
        courses: converted,
      }));
    }
  }, [courses]);

  useEffect(() => {
    if (!formData.country || !allStates.length) {
      setStates([]);
      if (formData.country === '') {
        setFormData((prev) => ({
          ...prev,
          state: '',
          city: '',
        }));
      }
      return;
    }

    const selectedCountry = countries.find(
      (country) =>
        String(
          country.name ||
            country.country_name ||
            country
        ) === String(formData.country)
    );

    if (!selectedCountry) {
      setStates([]);
      return;
    }

    const statesForCountry = allStates.filter(
      (state) =>
        String(state.countryId) ===
        String(selectedCountry.id)
    );

    setStates(statesForCountry);
  }, [formData.country, allStates, countries]);

  useEffect(() => {
    if (!formData.state || !allCities.length) {
      setCities([]);
      return;
    }

    const selectedState = allStates.find(
      (state) =>
        String(state.stateName) === String(formData.state)
    );

    if (!selectedState) {
      setCities([]);
      return;
    }

    const citiesForState = allCities.filter(
      (city) =>
        String(city.stateId) ===
        String(selectedState.stateId)
    );

    setCities(citiesForState);
  }, [formData.state, allCities, allStates]);

  useEffect(() => {
    setTempCourses([...formData.courses]);
  }, [formData.courses]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    let nextValue =
      type === 'checkbox' ? checked : value;

    if (name === 'mobileNo') {
      nextValue = value.replace(/\D/g, '').slice(0, 10);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: nextValue,
    }));

    if (formErrors[name]) {
      setFormErrors((prev) => ({
        ...prev,
        [name]: '',
      }));
    }

    if (name === 'country') {
      setFormData((prev) => ({
        ...prev,
        state: '',
        city: '',
      }));
    }

    if (name === 'state') {
      setFormData((prev) => ({
        ...prev,
        city: '',
      }));
    }
  };

  const getCourseName = (course) =>
    course?.name ||
    course?.course_name ||
    course?.title ||
    '';

  const handleSave = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!formData.registrationCode) {
      newErrors.registrationCode = 'Required';
    }

    if (!formData.candidateName) {
      newErrors.candidateName = 'Required';
    }

    if (!formData.gender) {
      newErrors.gender = 'Required';
    }

    if (
      !formData.mobileNo ||
      !/^\d{10}$/.test(formData.mobileNo)
    ) {
      newErrors.mobileNo =
        '10-digit mobile number required';
    }

    if (
      !formData.email ||
      !/\S+@\S+\.\S+/.test(formData.email)
    ) {
      newErrors.email = 'Valid email required';
    }

    if (!formData.dateOfBirth) {
      newErrors.dateOfBirth = 'Required';
    }

    if (!formData.country) {
      newErrors.country = 'Required';
    }

    if (!formData.state) {
      newErrors.state = 'Required';
    }

    if (!formData.city) {
      newErrors.city = 'Required';
    }

    if (!formData.address) {
      newErrors.address = 'Required';
    }

    if (!formData.nationality) {
      newErrors.nationality = 'Required';
    }

    if (!formData.registrationFee) {
      newErrors.registrationFee = 'Required';
    }

    if (!formData.courses?.length) {
      newErrors.courses =
        'Select at least one course';
    }

    if (!selectedBranchId) {
  newErrors.branch = 'Required';
}

    setFormErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setSnackbarMessage('Please fix the errors');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      return;
    }

    setIsSubmitting(true);

    const selectedBranchObj = branches.find(
      (branch) =>
        String(branch.id) ===
        String(formData.branch)
    );

    const selectedCountry = countries.find(
      (country) =>
        String(
          country.name ||
            country.country_name ||
            country
        ) === String(formData.country)
    );

    const selectedState = allStates.find(
      (state) =>
        String(state.stateName) ===
        String(formData.state)
    );

    const selectedCity = allCities.find(
      (city) =>
        String(city.cityName) ===
        String(formData.city)
    );

    const selectedNationality =
      nationalities.find(
        (nationality) =>
          String(
            nationality.name ||
              nationality.nationality ||
              nationality.nationality_name ||
              nationality
          ) === String(formData.nationality)
      );

    const selectedCourseIds = formData.courses
      .map((name) => {
        const course = courses.find(
          (item) =>
            String(getCourseName(item)) ===
            String(name) ||
            String(item.id) === String(name)
        );

        return course?.id;
      })
      .filter((id) => id != null);

    const payload = {
      registration_code:
        formData.registrationCode.trim(),
      registration_date:
        formData.registrationDate,
      candidate_name:
        formData.candidateName.trim(),
      gender: formData.gender,
      mobile_no: formData.mobileNo.trim(),
      email: formData.email.trim(),
      dob: formData.dateOfBirth,
      country: selectedCountry?.id || null,
      state: selectedState?.stateId || null,
      city: selectedCity?.cityId || null,
      address: formData.address.trim(),
      nationality:
        selectedNationality?.id || null,
      registration_fee: formData.registrationFee
        ? parseFloat(formData.registrationFee)
        : null,
      courses: selectedCourseIds,
      send_sms: formData.sendSMS,
      enquiry: selectedEnquiry?.id || null,
           branch: selectedBranchObj?.id || selectedBranchId || null,
      organization:
        selectedBranchObj?.organization ||
        selectedBranchObj?.organization_id ||
        organizationId ||
        null,
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}/api/student_details/registrations/${registrationId}/`,
        {
          method: 'PUT',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        const errorData = await response
          .json()
          .catch(() => ({}));

        throw new Error(
          errorData.detail ||
            errorData.message ||
            `HTTP ${response.status}`
        );
      }

      await response.json().catch(() => null);

      setShowSuccessModal(true);
      setSnackbarMessage(
        'Registration updated successfully'
      );
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
    } catch (err) {
      console.error('Update registration error:', err);
      setSnackbarMessage(
        err.message ||
          'Failed to update registration'
      );
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const filteredEnquiries = enquiries.filter((enq) => {
    if (!enquirySearchTerm) return true;

    const term =
      enquirySearchTerm.toLowerCase();

    return (
      String(enq.student_name || '')
        .toLowerCase()
        .includes(term) ||
      String(enq.enquiry_code || '')
        .toLowerCase()
        .includes(term) ||
      String(
        enq.contact_no ||
          enq.mobile_no ||
          ''
      ).includes(term) ||
      String(enq.parent_name || '')
        .toLowerCase()
        .includes(term)
    );
  });

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ my: 0 }}>
        <Box
          sx={{
            p: 4,
            borderRadius: 2,
            backgroundColor:
              theme.palette.background.paper,
          }}
        >
          <Typography>
            Loading registration...
          </Typography>
        </Box>
      </Container>
    );
  }

  if (fetchError) {
    return (
      <Container maxWidth="lg" sx={{ my: 0 }}>
        <Box
          sx={{
            p: 4,
            borderRadius: 2,
            backgroundColor:
              theme.palette.background.paper,
          }}
        >
          <Typography
            color="error"
            sx={{ mb: 2 }}
          >
            {fetchError}
          </Typography>
          <Button
            variant="outlined"
            onClick={() => navigate(-1)}
          >
            BACK
          </Button>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ my: 0 }}>
      <Box
        sx={{
          p: 4,
          borderRadius: 2,
          backgroundColor:
            theme.palette.background.paper,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 'bold',
              color: theme.palette.primary.main,
            }}
          >
            Edit Registration
          </Typography>
        </Box>

        {showSuccessModal ? (
          <Modal
            open={showSuccessModal}
            onClose={() =>
              setShowSuccessModal(false)
            }
            BackdropProps={{
              style: {
                backgroundColor:
                  'rgba(0, 0, 0, 0.8)',
              },
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform:
                  'translate(-50%, -50%)',
                width: 400,
                bgcolor:
                  theme.palette.background.paper,
                borderRadius: 2,
                boxShadow: 24,
                overflow: 'hidden',
              }}
            >
              <Box
                sx={{
                  backgroundColor:
                    theme.palette.primary.main,
                  padding: '12px 16px',
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    color:
                      theme.palette.primary
                        .contrastText,
                  }}
                >
                  Registration Updated ✅
                </Typography>
              </Box>

              <Box sx={{ padding: '20px' }}>
                <Typography sx={{ mb: 2 }}>
                  Registration Updated
                  Successfully
                </Typography>

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent:
                      'flex-end',
                    mt: 3,
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={() => {
                      setShowSuccessModal(false);
                      navigate(-1);
                    }}
                  >
                    OK
                  </Button>
                </Box>
              </Box>
            </Box>
          </Modal>
        ) : (
          <form onSubmit={handleSave}>
            <FormControlLabel
              control={
                <Checkbox
                  name="sendSMS"
                  checked={formData.sendSMS}
                  onChange={handleChange}
                  sx={{
                    color:
                      theme.palette.text.primary,
                    '&.Mui-checked': {
                      color:
                        theme.palette.text
                          .primary,
                    },
                  }}
                />
              }
              label="Send SMS"
              sx={{ mb: 3 }}
            />

           <TextField
  label="Enquiry *"
  variant="outlined"
  fullWidth
  value={
    selectedEnquiry
      ? `${
          selectedEnquiry.enquiry_code ||
          'ENQ-' +
            selectedEnquiry.id
        } - ${
          selectedEnquiry.student_name ||
          selectedEnquiry.candidate_name ||
          selectedEnquiry.name ||
          'Unknown'
        }`
      : 'Not linked'
  }
  InputProps={{
    readOnly: true,
    disabled: true,
  }}
  InputLabelProps={{
    shrink: true,
  }}
  helperText="Enquiry is locked in edit mode (cannot be changed after registration)"
 sx={{
  ...inputSx,
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: theme.palette.text.primary,
    color: theme.palette.text.primary,
    opacity: 0.9,
  },
}}
  required
/>

            <TextField
              label="Registration Code"
              variant="outlined"
              fullWidth
              name="registrationCode"
              value={formData.registrationCode}
              onChange={handleChange}
              disabled
              error={
                !!formErrors.registrationCode
              }
              helperText={
                formErrors.registrationCode
              }
              sx={inputSx}
              required
            />

            <TextField
              label="Registration Date"
              type="date"
              variant="outlined"
              fullWidth
              name="registrationDate"
              value={
                formData.registrationDate
              }
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                ...inputSx,
                '& .MuiInputBase-input[type="date"]::-webkit-calendar-picker-indicator':
                  {
                    filter:
                      theme.palette.mode ===
                      'dark'
                        ? 'invert(1)'
                        : 'none',
                  },
              }}
              required
            />

            <TextField
              label="Candidate Name"
              variant="outlined"
              fullWidth
              name="candidateName"
              value={formData.candidateName}
              onChange={handleChange}
              error={
                !!formErrors.candidateName
              }
              helperText={
                formErrors.candidateName
              }
              sx={inputSx}
              required
            />

            <FormControl
              fullWidth
              sx={{ mb: 3 }}
              required
              error={!!formErrors.gender}
            >
              <InputLabel
                sx={{
                  color:
                    theme.palette.text.primary,
                  '&.Mui-focused': {
                    color:
                      theme.palette.primary
                        .main,
                  },
                }}
              >
                Gender
              </InputLabel>

              <Select
                name="gender"
                value={formData.gender}
                label="Gender"
                onChange={handleChange}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline':
                    {
                      borderColor:
                        theme.palette.text
                          .primary,
                    },
                  '&:hover .MuiOutlinedInput-notchedOutline':
                    {
                      borderColor:
                        theme.palette.primary
                          .main,
                    },
                }}
              >
                {staticGenderData.map(
                  (gender) => (
                    <MenuItem
                      key={gender.id}
                      value={gender.name}
                    >
                      {gender.name}
                    </MenuItem>
                  )
                )}
              </Select>

              {formErrors.gender && (
                <FormHelperText>
                  {formErrors.gender}
                </FormHelperText>
              )}
            </FormControl>

            <TextField
              label="Mobile No."
              type="tel"
              inputProps={{
                maxLength: 10,
                inputMode: 'numeric',
              }}
              variant="outlined"
              fullWidth
              name="mobileNo"
              value={formData.mobileNo}
              onChange={handleChange}
              error={!!formErrors.mobileNo}
              helperText={
                formErrors.mobileNo ||
                'Enter 10-digit mobile number'
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Select
                      value={
                        mobileCountryCode
                      }
                      onChange={(e) =>
                        setMobileCountryCode(
                          e.target.value
                        )
                      }
                      variant="standard"
                      disableUnderline
                      sx={{
                        minWidth: 70,
                        '& .MuiSelect-select':
                          {
                            py: 0.5,
                            px: 1,
                            fontSize:
                              '0.875rem',
                            color:
                              theme.palette
                                .text.primary,
                          },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 300,
                          },
                        },
                      }}
                    >
                      {COUNTRY_CODES.map(
                        ([code, label]) => (
                          <MenuItem
                            key={code}
                            value={code}
                          >
                            {label}
                          </MenuItem>
                        )
                      )}
                    </Select>

                    <Box
                      sx={{
                        width: '1px',
                        height: '24px',
                        backgroundColor:
                          theme.palette
                            .divider,
                        mx: 0.5,
                      }}
                    />
                  </InputAdornment>
                ),
              }}
              sx={inputSx}
              required
            />

            <TextField
              label="Email"
              type="email"
              variant="outlined"
              fullWidth
              name="email"
              value={formData.email}
              onChange={handleChange}
              error={!!formErrors.email}
              helperText={formErrors.email}
              sx={inputSx}
              required
            />

            <TextField
              label="Date of Birth"
              type="date"
              variant="outlined"
              fullWidth
              name="dateOfBirth"
              value={formData.dateOfBirth}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              error={
                !!formErrors.dateOfBirth
              }
              helperText={
                formErrors.dateOfBirth
              }
              sx={{
                ...inputSx,
                '& .MuiInputBase-input[type="date"]::-webkit-calendar-picker-indicator':
                  {
                    filter:
                      theme.palette.mode ===
                      'dark'
                        ? 'invert(1)'
                        : 'none',
                  },
              }}
              required
            />

            <FormControl
              fullWidth
              sx={{ mb: 3 }}
              required
              error={!!formErrors.country}
            >
              <InputLabel
                sx={{
                  color:
                    theme.palette.text.primary,
                  '&.Mui-focused': {
                    color:
                      theme.palette.primary
                        .main,
                  },
                }}
              >
                Country
              </InputLabel>

              <Select
                name="country"
                value={formData.country}
                label="Country"
                onChange={handleChange}
              >
                {countries.map(
                  (country, index) => (
                    <MenuItem
                      key={
                        country.id || index
                      }
                      value={
                        country.name ||
                        country.country_name ||
                        country
                      }
                    >
                      {country.name ||
                        country.country_name ||
                        country}
                    </MenuItem>
                  )
                )}
              </Select>

              {formErrors.country && (
                <FormHelperText>
                  {formErrors.country}
                </FormHelperText>
              )}
            </FormControl>

            <FormControl
              fullWidth
              sx={{ mb: 3 }}
              required
              error={!!formErrors.state}
            >
              <InputLabel
                sx={{
                  color:
                    theme.palette.text.primary,
                  '&.Mui-focused': {
                    color:
                      theme.palette.primary
                        .main,
                  },
                }}
              >
                State
              </InputLabel>

              <Select
                name="state"
                value={formData.state}
                label="State"
                onChange={handleChange}
                disabled={!formData.country}
              >
                {states.map((state) => (
                  <MenuItem
                    key={state.stateId}
                    value={state.stateName}
                  >
                    {state.stateName}
                  </MenuItem>
                ))}
              </Select>

              {formErrors.state && (
                <FormHelperText>
                  {formErrors.state}
                </FormHelperText>
              )}
            </FormControl>

            <FormControl
              fullWidth
              sx={{ mb: 3 }}
              required
              error={!!formErrors.city}
            >
              <InputLabel
                sx={{
                  color:
                    theme.palette.text.primary,
                  '&.Mui-focused': {
                    color:
                      theme.palette.primary
                        .main,
                  },
                }}
              >
                City
              </InputLabel>

              <Select
                name="city"
                value={formData.city}
                label="City"
                onChange={handleChange}
                disabled={!formData.state}
              >
                {cities.map((city) => (
                  <MenuItem
                    key={city.cityId}
                    value={city.cityName}
                  >
                    {city.cityName}
                  </MenuItem>
                ))}
              </Select>

              {formErrors.city && (
                <FormHelperText>
                  {formErrors.city}
                </FormHelperText>
              )}
            </FormControl>

            <TextField
              label="Address"
              variant="outlined"
              fullWidth
              name="address"
              value={formData.address}
              onChange={handleChange}
              error={!!formErrors.address}
              helperText={formErrors.address}
              sx={inputSx}
              required
            />

            <FormControl
              fullWidth
              sx={{ mb: 3 }}
              required
              error={!!formErrors.nationality}
            >
              <InputLabel
                sx={{
                  color:
                    theme.palette.text.primary,
                  '&.Mui-focused': {
                    color:
                      theme.palette.primary
                        .main,
                  },
                }}
              >
                Nationality
              </InputLabel>

              <Select
                name="nationality"
                value={formData.nationality}
                label="Nationality"
                onChange={handleChange}
              >
                {nationalities.map(
                  (nationality, index) => (
                    <MenuItem
                      key={
                        nationality.id ||
                        index
                      }
                      value={
                        nationality.name ||
                        nationality.nationality ||
                        nationality.nationality_name ||
                        nationality
                      }
                    >
                      {nationality.name ||
                        nationality.nationality ||
                        nationality.nationality_name ||
                        nationality}
                    </MenuItem>
                  )
                )}
              </Select>

              {formErrors.nationality && (
                <FormHelperText>
                  {formErrors.nationality}
                </FormHelperText>
              )}
            </FormControl>

            <TextField
              required
              type="number"
              label="Registration Fee"
              variant="outlined"
              fullWidth
              name="registrationFee"
              value={formData.registrationFee}
              onChange={handleChange}
              error={
                !!formErrors.registrationFee
              }
              helperText={
                formErrors.registrationFee
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <span
                      style={{
                        color:
                          theme.palette.text
                            .primary,
                      }}
                    >
                      ₹
                    </span>
                  </InputAdornment>
                ),
              }}
              sx={inputSx}
            />

            <FormControl
              fullWidth
              sx={{ mb: 3 }}
              required
              error={!!formErrors.courses}
            >
              <TextField
                label="Course(s) *"
                variant="outlined"
                fullWidth
                value={formData.courses.join(
                  ', '
                )}
                placeholder="Click to select courses"
                onClick={() => {
                  setTempCourses([
                    ...formData.courses,
                  ]);
                  setCourseModalOpen(true);
                }}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setTempCourses([
                            ...formData.courses,
                          ]);
                          setCourseModalOpen(
                            true
                          );
                        }}
                        edge="end"
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={
                  !!formErrors.courses
                }
                helperText={
                  formErrors.courses ||
                  'Click the search icon to select courses'
                }
                sx={{
                  cursor: 'pointer',
                  ...inputSx,
                }}
              />
            </FormControl>

            <Modal
              open={courseModalOpen}
              onClose={() =>
                setCourseModalOpen(false)
              }
              BackdropProps={{
                style: {
                  backgroundColor:
                    'rgba(0, 0, 0, 0.8)',
                },
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform:
                    'translate(-50%, -50%)',
                  width: {
                    xs: '90%',
                    md: 500,
                  },
                  maxHeight: '80vh',
                  bgcolor:
                    theme.palette.background
                      .paper,
                  borderRadius: 2,
                  boxShadow: 24,
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection:
                    'column',
                }}
              >
                <Box
                  sx={{
                    p: 2,
                    bgcolor:
                      theme.palette.primary
                        .main,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      color:
                        theme.palette.primary
                          .contrastText,
                      fontWeight: 'bold',
                    }}
                  >
                    Select Courses
                  </Typography>
                </Box>

                <CustomTableScrollbar
                  sx={{
                    flex: 1,
                    overflowY: 'auto',
                    p: 2,
                  }}
                >
                  {courses.map(
                    (course, index) => {
                      const courseName =
                        getCourseName(
                          course
                        );

                      const isChecked =
                        tempCourses.includes(
                          courseName
                        );

                      return (
                        <FormControlLabel
                          key={
                            course.id ||
                            index
                          }
                          control={
                            <Checkbox
                              checked={
                                isChecked
                              }
                              onChange={(
                                e
                              ) => {
                                if (
                                  e.target
                                    .checked
                                ) {
                                  setTempCourses(
                                    (
                                      prev
                                    ) =>
                                      prev.includes(
                                        courseName
                                      )
                                        ? prev
                                        : [
                                            ...prev,
                                            courseName,
                                          ]
                                  );
                                } else {
                                  setTempCourses(
                                    (
                                      prev
                                    ) =>
                                      prev.filter(
                                        (item) =>
                                          item !==
                                          courseName
                                      )
                                  );
                                }
                              }}
                              sx={{
                                color:
                                  theme.palette
                                    .primary
                                    .main,
                                '&.Mui-checked':
                                  {
                                    color:
                                      theme
                                        .palette
                                        .primary
                                        .main,
                                  },
                              }}
                            />
                          }
                          label={courseName}
                          sx={{
                            display: 'flex',
                            width: '100%',
                            mb: 1,
                            '& .MuiTypography-root':
                              {
                                color:
                                  theme
                                    .palette
                                    .text
                                    .primary,
                              },
                          }}
                        />
                      );
                    }
                  )}
                </CustomTableScrollbar>

                {tempCourses.length >
                  0 && (
                  <Box
                    sx={{
                      p: 2,
                      borderTop: `1px solid ${theme.palette.divider}`,
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{
                        mb: 1,
                        fontWeight: 'bold',
                        color:
                          theme.palette.primary
                            .main,
                      }}
                    >
                      Selected Courses:
                    </Typography>

                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap:
                          'wrap',
                        gap: 0.5,
                      }}
                    >
                      {tempCourses.map(
                        (course) => (
                          <Chip
                            key={course}
                            label={course}
                            size="small"
                            onDelete={() =>
                              setTempCourses(
                                (prev) =>
                                  prev.filter(
                                    (item) =>
                                      item !==
                                      course
                                  )
                              )
                            }
                            deleteIcon={
                              <CloseIcon />
                            }
                            sx={{
                              backgroundColor:
                                theme
                                  .palette
                                  .primary
                                  .main,
                              color:
                                theme
                                  .palette
                                  .primary
                                  .contrastText,
                            }}
                          />
                        )
                      )}
                    </Box>
                  </Box>
                )}

                <Box
                  sx={{
                    p: 2,
                    display: 'flex',
                    justifyContent:
                      'flex-end',
                    borderTop: `1px solid ${theme.palette.divider}`,
                    gap: 2,
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() =>
                      setCourseModalOpen(
                        false
                      )
                    }
                   data-app-cancel="true">
                    Cancel
                  </Button>

                  <Button
                    variant="contained"
                    onClick={() => {
                      setFormData(
                        (prev) => ({
                          ...prev,
                          courses: [
                            ...tempCourses,
                          ],
                        })
                      );
                      setCourseModalOpen(
                        false
                      );
                    }}
                  >
                    OK
                  </Button>
                </Box>
              </Box>
            </Modal>

            <Box
              sx={{
                display: 'flex',
                justifyContent:
                  'flex-end',
                gap: 2,
              }}
            >
              <Tooltip
                title={
                  !formData.registrationCode
                    ? 'Registration Code missing'
                    : !formData.candidateName
                      ? 'Enter Candidate Name'
                      : !formData.gender
                        ? 'Select Gender'
                        : !formData.mobileNo
                          ? 'Enter Mobile No.'
                          : !formData.email
                            ? 'Enter Email'
                            : !formData.dateOfBirth
                              ? 'Enter Date of Birth'
                              : !selectedBranchId
                                ? 'Select Branch'
                                : !formData.country
                                  ? 'Select Country'
                                  : !formData.state
                                    ? 'Select State'
                                    : !formData.city
                                      ? 'Select City'
                                      : !formData.address
                                        ? 'Enter Address'
                                        : !formData.nationality
                                          ? 'Select Nationality'
                                          : !formData.registrationFee
                                            ? 'Enter Registration Fee'
                                            : !formData.courses?.length
                                              ? 'Select Course'
                                              : ''
                }
                arrow
              >
                <span>
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={
                      !formData.registrationCode ||
                      !formData.candidateName ||
                      !formData.gender ||
                      !formData.mobileNo ||
                      !formData.email ||
                      !formData.dateOfBirth ||
                      !formData.branch ||
                      !formData.country ||
                      !formData.state ||
                      !formData.city ||
                      !formData.address ||
                      !formData.nationality ||
                      !formData.registrationFee ||
                      !formData.courses?.length ||
                      isSubmitting
                    }
                  >
                    {isSubmitting
                      ? 'UPDATING...'
                      : 'UPDATE'}
                  </Button>
                </span>
              </Tooltip>

              <Button
                variant="outlined"
                color="error"
                onClick={handleCancel}
                disabled={isSubmitting}
              >
                CANCEL
              </Button>
            </Box>
          </form>
        )}
      </Box>

      <Modal
        open={enquiryModalOpen}
        onClose={() =>
          setEnquiryModalOpen(false)
        }
        aria-labelledby="enquiry-modal-title"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform:
              'translate(-50%, -50%)',
            width: {
              xs: '90%',
              md: 900,
            },
            maxHeight: '85vh',
            bgcolor:
              theme.palette.background.paper,
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              p: 3,
              bgcolor:
                theme.palette.primary.main,
              color: 'white',
            }}
          >
            <Typography
              id="enquiry-modal-title"
              variant="h6"
            >
              Enquiries
            </Typography>
          </Box>

          <Box
            sx={{
              p: 2,
              borderBottom: `1px solid ${theme.palette.divider}`,
            }}
          >
            <TextField
              fullWidth
              size="small"
              placeholder="Search by name, code, mobile..."
              value={enquirySearchTerm}
              onChange={(e) =>
                setEnquirySearchTerm(
                  e.target.value
                )
              }
            />
          </Box>

          <CustomTableScrollbar
            sx={{
              flex: 1,
              overflowY: 'auto',
            }}
          >
            <table
              style={{
                width: '100%',
                borderCollapse:
                  'collapse',
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor:
                      theme.palette.action
                        .hover,
                  }}
                >
                  <th
                    style={{
                      padding: 12,
                      textAlign:
                        'left',
                    }}
                  >
                    Enquiry ID
                  </th>
                  <th
                    style={{
                      padding: 12,
                      textAlign:
                        'left',
                    }}
                  >
                    Student Name
                  </th>
                  <th
                    style={{
                      padding: 12,
                      textAlign:
                        'left',
                    }}
                  >
                    Enquiry Code
                  </th>
                  <th
                    style={{
                      padding: 12,
                      textAlign:
                        'left',
                    }}
                  >
                    Parent/Guardian
                  </th>
                  <th
                    style={{
                      padding: 12,
                      textAlign:
                        'left',
                    }}
                  >
                    Contact No.
                  </th>
                  <th
                    style={{
                      padding: 12,
                      textAlign:
                        'left',
                    }}
                  >
                    Enquiry Date
                  </th>
                  <th
                    style={{
                      padding: 12,
                      textAlign:
                        'center',
                    }}
                  >
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {filteredEnquiries.map(
                  (enq) => (
                    <tr
                      key={enq.id}
                      style={{
                        borderBottom: `1px solid ${theme.palette.divider}`,
                      }}
                    >
                      <td
                        style={{
                          padding: 12,
                        }}
                      >
                        {enq.id}
                      </td>

                      <td
                        style={{
                          padding: 12,
                        }}
                      >
                        {enq.student_name ||
                          enq.candidate_name ||
                          '-'}
                      </td>

                      <td
                        style={{
                          padding: 12,
                        }}
                      >
                        {enq.enquiry_code ||
                          '-'}
                      </td>

                      <td
                        style={{
                          padding: 12,
                        }}
                      >
                        {enq.parent_name ||
                          enq.guardian ||
                          '-'}
                      </td>

                      <td
                        style={{
                          padding: 12,
                        }}
                      >
                        {enq.contact_no ||
                          enq.mobile_no ||
                          '-'}
                      </td>

                      <td
                        style={{
                          padding: 12,
                        }}
                      >
                        {enq.enquiry_date ||
                          '-'}
                      </td>

                      <td
                        style={{
                          padding: 12,
                          textAlign:
                            'center',
                        }}
                      >
                        <Button
                          variant="contained"
                          size="small"
                          onClick={() => {
                            setSelectedEnquiry(
                              enq
                            );
                            setEnquiryModalOpen(
                              false
                            );
                          }}
                        >
                          SELECT
                        </Button>
                      </td>
                    </tr>
                  )
                )}

                {filteredEnquiries.length ===
                  0 && (
                  <tr>
                    <td
                      colSpan={7}
                      style={{
                        padding: 20,
                        textAlign:
                          'center',
                        color:
                          theme.palette.text
                            .secondary,
                      }}
                    >
                      No matching
                      enquiries found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </CustomTableScrollbar>

          <Box
            sx={{
              p: 2,
              display: 'flex',
              justifyContent:
                'flex-end',
              borderTop: `1px solid ${theme.palette.divider}`,
            }}
          >
            <Button
              variant="outlined"
              onClick={() =>
                setEnquiryModalOpen(
                  false
                )
              }
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() =>
          setOpenSnackbar(false)
        }
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Alert
          onClose={() =>
            setOpenSnackbar(false)
          }
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default EditRegistration;
